
import Vue from 'vue';
import { Data as ArticleData } from '@root/modules/article/types/article';

interface Props {
  adsDisabled: boolean;
  articleId: ArticleData['id'];
}

interface Computed {
  maintenanceMode: boolean;
  hideOrdering: boolean;
  isCrArticle: boolean;
}

export default Vue.extend<unknown, unknown, Computed, Props>({
  props: {
    adsDisabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    articleId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    maintenanceMode() {
      return this.$store.state.piano.config.maintenanceMode;
    },
    hideOrdering() {
      const { specialFeatures } = this.$channelConfig('settings').application;
      return specialFeatures.hideSignupAndOrders.enabled;
    },
    isCrArticle() {
      const articles = this.$store.getters['article/getCrArticles'];
      return articles.find((article: number) => article === this.articleId);
    },
  },
  async mounted() {
    const composerTarget = this.$el.querySelector('.article-newsletter__composer-target');
    if (composerTarget) {
      const observer = new MutationObserver(() => {
        if (composerTarget.childNodes.length > 0) {
          composerTarget.classList.remove('article-newsletter__composer-target');
          observer.disconnect();
        }
      });
      observer.observe(composerTarget, { childList: true, subtree: true });
    }
    const unwatch = this.$store.watch(
      (state) => state.piano.experience.ready,
      async (ready: boolean) => {
        if (this.isCrArticle && ready) {
          this.$store.dispatch('piano/executeExperience');
          await this.$nextTick();
          unwatch();
        }
      },
      {
        immediate: true,
      }
    );
  },
});
